<template>
  <v-container class="formulario-wrapper" fluid pa-0>
    <div class="content-container elevation-2">

      <v-card :disabled="loading">
        <v-card-text class="pt-4">
          <v-form ref="form" @submit.prevent="salvarVisita">
            
            <v-row dense class="mb-2">
              <v-col cols="12">
                <div class="grey--text mb-1">Cliente Selecionado (ID: {{ idCliente }})</div>
                <div class="subtitle-1 font-weight-bold mb-3">{{ nomeCliente || 'Carregando nome...' }}</div>
                
                <div class="grey--text mb-1">Última Visita Registrada</div>
                <v-text-field
                  v-model="ultimaVisita"
                  prepend-inner-icon="mdi-history"
                  outlined
                  dense
                  readonly
                  background-color="#f9f9f9"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>
            
            <div class="subtitle-2 primary--text mb-3">Dados da Visita Atual</div>

            <v-row dense>
              <v-col cols="12">
                <v-select
                  v-model="motivoSelecionado"
                  :items="motivos"
                  label="Motivo da Visita"
                  prepend-inner-icon="mdi-format-list-bulleted"
                  outlined
                  dense
                  background-color="white"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="observacao"
                  label="Observação"
                  outlined
                  dense
                  rows="4"
                  auto-grow
                  background-color="white"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 grey lighten-5">
          <v-btn text color="black darken-1" @click="voltar" :disabled="loading">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="salvarVisita" :loading="loading" elevation="2">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie'; 

export default {
  name: 'ViewCadastroVisita',

  data() {
    return {
      loading: false,
      idCliente: null,
      nomeCliente: '',
      ultimaVisita: 'Consultando...', 
      motivoSelecionado: 'Não Estava',
      motivos: [
        'Não Estava',   
        'Estoque Completo', 
        'Outros',  
      ],
      observacao: '',
      idVendedorAtual: null, 
    };
  },
  async created() {
    window.scrollTo(0, 0);
  
    await this.carregarVendedor();

    let idRecuperado = this.$route.query.idCliente || this.$route.query.clienteCodigo;
    
    if (!idRecuperado) {
      console.warn("⚠️ NENHUM ID NA URL. Usando ID 1 para testes.");
      idRecuperado = 1; 
    }

    this.idCliente = parseInt(idRecuperado, 10);
    this.carregarDadosCliente();
    this.carregarUltimaVisita(this.idCliente);
  },

  methods: {

    async carregarVendedor() {
      try {
        const idSessao = sessionStorage.getItem('venidnuvem'); 
        
        if (idSessao) {
          this.idVendedorAtual = parseInt(idSessao);
        } 
        else {
          const lastCode = localStorage.getItem('last_login_code');
          if (lastCode) {
            const vendedorLocal = await db.vendedor
                .where({ codigo: parseInt(lastCode) })
                .first();
                
            if (vendedorLocal) {
              this.idVendedorAtual = vendedorLocal.venidnuvem || vendedorLocal.idvendedor;
            }
          }
        }
      } catch (e) {
        console.error("Erro ao carregar vendedor:", e);
      }
    },

    async carregarDadosCliente() {
      try {
        const cliente = await db.cliente.get(this.idCliente);
        if (cliente) {
          this.nomeCliente = cliente.nome || cliente.nomefantasia;
        } else {
          this.nomeCliente = "Cliente não encontrado no banco local";
        }
      } catch (e) {
        console.log("Erro ao buscar nome cliente", e);
      }
    },

    async carregarUltimaVisita(idCliente) {
      try {
        const ultima = await db.visita
          .filter(visita => visita.idcliente === idCliente)
          .last(); 

        if (ultima && ultima.datavisita) {
          const dataObj = new Date(ultima.datavisita);
          const dataStr = dataObj.toLocaleDateString('pt-BR');
          const horaStr = dataObj.toLocaleTimeString('pt-BR');
          this.ultimaVisita = `${dataStr} às ${horaStr}`;
        } else {
          this.ultimaVisita = 'Nenhuma visita registrada';
        }
      } catch (error) {
        console.error("Erro ao carregar última visita:", error);
        this.ultimaVisita = "Não foi possível carregar";
      }
    },

    async salvarVisita() {
      this.loading = true;
      
      if (!this.idVendedorAtual) {
          alert("Erro: Vendedor não identificado. Faça login novamente.");
          this.loading = false;
          return;
      }

      const coords = await this._obterLocalizacao();
      
      // Log para debug
      // console.log("Coordenadas finais para salvar:", coords);

      const agora = new Date();
      const dataFormatada = agora.toISOString(); 
      const motivoIndex = this.motivos.indexOf(this.motivoSelecionado);
      const motivoId = motivoIndex + 1; 

      const visitaLocal = {
        datavisita: dataFormatada,
        datavigitacao: dataFormatada,
        idcliente: this.idCliente,
        motivo: motivoId,
        observacao: this.observacao || '',
        latitude: coords ? coords.lat : 0,
        longitude: coords ? coords.lng : 0,
        atendido: 0, 
        sync: 0,
        idremoto: null,
        idvendedor: parseInt(this.idVendedorAtual)
      };

      try {
        const idDexie = await db.visita.add(visitaLocal);
        console.log(`Visita salva localmente (Offline). ID Dexie: ${idDexie}`);
        this.$emit('sucesso', 'Visita salva localmente!');
        this.voltar();
      } catch (error) {
        console.error("Erro ao salvar no Dexie:", error);
        alert('Erro ao salvar dados no dispositivo.');
      } finally {
        this.loading = false;
      }
    },

    _obterLocalizacao() {
      return new Promise((resolve) => {
        
        const latStore = localStorage.getItem('msUtil_latitude');
        const lngStore = localStorage.getItem('msUtil_longitude');

        if (latStore && lngStore) {
          // console.log("Usando localização do cache (App.vue)");
          resolve({ 
            lat: parseFloat(latStore), 
            lng: parseFloat(lngStore) 
          });
          return;
        }
        console.warn("Sem cache no Storage, tentando hardware direto...");
        
        if (!('geolocation' in navigator)) {
          resolve(null);
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude });
          },
          (err) => {
            console.error("Erro ao pegar GPS no momento do clique:", err);
            resolve(null);
          },
          { timeout: 5000, enableHighAccuracy: false }
        );
      });
    },

    voltar() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}
.content-container {
  width: 100%;
  max-width: 600px; 
  margin-top: 10px;
}
</style>